import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowRight, FileText, Loader2 } from 'lucide-react';

interface AssessmentCompleteProps {
  sessionId: string;
  computing?: boolean;
}

export function AssessmentComplete({ sessionId, computing }: AssessmentCompleteProps) {
  // Build report URL without secrets in query params (security: secrets stored in localStorage only)
  const reportUrl = `/inventory/report/${sessionId}`;

  return (
    <div className="max-w-xl mx-auto text-center animate-fade-up">
      <div className="card-premium py-12">
        {computing ? (
          <>
            <Loader2 className="h-16 w-16 text-primary mx-auto mb-6 animate-spin" />
            <h1 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-4">
              Generating Your Report
            </h1>
            <p className="text-muted-foreground leading-relaxed">
              We're analysing your responses and preparing your personalised 
              leadership and partnership insights...
            </p>
          </>
        ) : (
          <>
            <CheckCircle className="h-16 w-16 text-primary mx-auto mb-6" />
            <h1 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-4">
              Assessment Complete
            </h1>
            <p className="text-muted-foreground mb-8 leading-relaxed">
              Thank you for completing the GP Partnership Lab Inventory. 
              Your personalised report is ready.
            </p>
            
            <div className="space-y-4">
              <Link to={reportUrl}>
                <Button variant="hero" size="xl" className="w-full">
                  <FileText className="h-5 w-5" />
                  View Your Report
                </Button>
              </Link>
              
              <Link to="/">
                <Button variant="ghost" className="w-full">
                  Return to Home
                </Button>
              </Link>
            </div>
          </>
        )}
      </div>

      <p className="text-sm text-muted-foreground mt-6">
        Your individual responses remain confidential. 
        Only you can access your personal report.
      </p>
    </div>
  );
}
